// extracted by mini-css-extract-plugin
export default {"container":"Benefits_container__faSv9","title":"Benefits_title__PJLnr","text":"Benefits_text__M9C1M"};